import React from 'react';

const MfpDashboardPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true,
			},
		},
	},
	auth: ['dashboardsTab.mfpDashboardSection.view'],
	routes: [
		{
			path: '/admin/dashboards/mfp',
			exact: true,
			component: React.lazy(() => import('./MfpDashboardPage')),
		},
	],
};

export default MfpDashboardPageConfig;
